import { makeStyles } from 'tss-react/mui';
import { spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    floristDetailsContainer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 102,
        backgroundColor: colors.supplementary.white,
        width: '100%',
        padding: `${spacing.medium} 20px`,
        left: 0,
    },
    floristInfo: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    floristName: Object.assign(Object.assign({}, theme.typography.small_bold), { marginBottom: 0, color: colors.supplementary.black, width: '70%', maxHeight: '52px', overflow: 'hidden', [theme.breakpoints.up('xl')]: {
            width: '80%',
        } }),
    floristDistance: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.grey.grey6 }),
    floristAddressDetails: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.grey.grey6 }),
    floristDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'start',
        marginTop: spacing.large,
    },
    floristShopTimings: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.grey.grey6, marginBottom: spacing.small }),
}));
export default useStyles;
